import React from "react";
import { amenityIconFilterClass } from "../../utils/amenityIcon";

const PropertyAmenities = ({ free}) => {
  return (
    <>
      <h3 className="font-bold text-start ml-10 text-[22px] underline w-full mb-5 text-black">
        Property Amenities
      </h3>
      <div className="flex flex-row ml-10 justify-center">
        <div className="flex md:flex-1 flex-col  items-start">
          <h3 className="font-semibold  text-[22px] underline text-black">
            Free
          </h3>
          <ul className="flex flex-row md:flex-col">
          {free.slice(0,free.length/2).map((a) => (
                        <li className="mr-10 my-3 text-black flex flex-row">
                          <img
                            src={a.icon.file}
                            alt={a.name}
                            className={`w-[25px] h-[25px] mr-2 object-contain ${amenityIconFilterClass(a.name)}`}
                          />
                          {a.name}
                          </li>
                      ))}
          </ul>
        </div>
        <div className="flex md:flex-1 flex-col  items-start ">
          <h3 className="font-semibold  text-[22px] underline text-black">
            Free
          </h3>
          <ul className="flex flex-row md:flex-col">
          {free.slice(free.length/2,free.length).map((a) => (
                        <li className="mr-10 my-3 text-black flex flex-row">
                          <img
                            src={a.icon.file}
                            alt={a.name}
                            className={`w-[25px] h-[25px] mr-2 object-contain ${amenityIconFilterClass(a.name)}`}
                          />
                          {a.name}
                          </li>
                      ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default PropertyAmenities;
